export const GET_ACTIVE_SUPPORT_USERS = "/users/activesupportusers";
export const CREATE_USER = "/users/support/user";
export const ADD_USER_ROLE = "/users/support/user/role";
export const GET_USER_DETAILS = "/users/support/user/email";
export const REMOVE_ROLES = "/users/support/user/role";
export const BUSINESS_DETAILS = "/datacollectionbusiness/support/login/details";
export const BUSINESS_UNLOCK = "/datacollectionbusiness/support/login/unlock";
export const UPDATE_BUSINESS_LOGIN =
  "/datacollectionbusiness/support/login/email";
export const GENERATE_LOGIN_PIN = "/datacollectionbusiness/support/generatepin";
export const UPDATE_ADMIN_EMAIL = (businessId: string) =>
  `/users/support/business/${businessId}/adminemail`;

// Business Reports API endpoint
export const GENERATE_BUSINESS_REPORT = (
  businessId: string,
  reportName: string
) => `/loyaltyprogram/business/${businessId}/report/${reportName}`;

// Settings API endpoints
export const GET_BUSINESS_SETTINGS = (businessId: string, category: string) =>
  `/setting/business/${businessId}/category/${category}`;
export const UPDATE_BUSINESS_SETTINGS = (businessId: string) =>
  `/setting/business/${businessId}`;

// Video API endpoints
export const GET_BUSINESS_VIDEOS = (businessId: string) =>
  `/datacollectionbusiness/support/videos/business/${businessId}`;
export const ADD_DEFAULT_VIDEO =
  "/datacollectionbusiness/support/video/default";
export const ADD_VIDEO = "/datacollectionbusiness/support/video";
export const ACTIVATE_VIDEO = (videoId: string) =>
  `/datacollectionbusiness/support/videos/${videoId}/activate`;
export const DEACTIVATE_VIDEO = (videoId: string) =>
  `/datacollectionbusiness/support/videos/${videoId}/deactivate`;
export const SEARCH_USER_BY_STRING = "/users/support";
export const SEARCH_GROUPED_USER_ACCOUNT = "/users/groupuseraccounts/support";
export const DELETE_USER_ACCOUNT = "/users/support/user/anonymize";
export const GET_CONSUMER_APP_USAGE_STATS = "/consumerapp/usage/stats";
export const RIBBIONS_TRANSACTIONS_LIST = "/v2/ribbontransactions";
export const RIBBINGS_TOTAL_BALANCE = "/v1/ribbons/totalbalance/";
export const GET_BUSINESS_DEVICES =
  "businessdevicemanagementnode/v1/businessdevice";
export const SEND_PUSH_NOTIFICATION =
  "businessdevicemanagement/v1/fcm/push/device";
export const COMMISSION_AND_DECOMMISSION =
  "businessdevicemanagementnode/v1/businessdevice";

// Portal Rewards API paths
export const GET_REWARDS_PATH = "/loyaltyprogram/businessportal/rewards";
export const CREATE_REWARD_PATH = "/loyaltyprogram/businessportal/reward";
export const UPDATE_REWARD_PATH = "/loyaltyprogram/businessportal/reward";

// Portal QR Code API paths
export const GET_JOIN_QRCODE_PATH = "/loyaltyprogram/support/qrcode/join";
export const GENERATE_JOIN_QRCODE_PATH = "/loyaltyprogram/support/qrcode/join";
export const SAVE_JOIN_REWARD_PATH =
  "/loyaltyprogram/support/qrcode/join/reward";

// Redis API endpoints
export const REDIS_GET = "/utilities/redis/get";
export const REDIS_SET = "/utilities/redis/set";

// Business Email API endpoints
export const GET_SENT_EMAILS = (businessId: string) =>
  `/users/sentemails/${businessId}`;

// Support email change (account recovery) API endpoints.
// NOTE: these are guarded by SupportAuthorizer in bearer-token mode. The shared
// x-api-key-value key passes the authorizer but carries no agent identity, so
// every one of these endpoints answers 403 UNAUTHORIZED for key-based calls.
// Always attach the signed-in support agent's own JWT.
export const EMAIL_CHANGE_START = "/users/support/user/emailchange/start";
export const EMAIL_CHANGE_OTP = "/users/support/user/emailchange/otp";
export const EMAIL_CHANGE_COMPLETE = "/users/support/user/emailchange/complete";
export const EMAIL_CHANGE_STATE = (userId: string) =>
  `/users/support/user/emailchange/${userId}`;
